<div class="container-fluid" *ngIf="contract && actions.length > 0">
  <ngx-resource-actions [actions]="actions"> </ngx-resource-actions>
</div>
